import angular from 'angular'
import sourceErrorCtrl from './sourceErrorCtrl'
import { sourceErrorRouter, sourceErrorListRouter, sourceErrorDetailRouter } from './Routers'
import { sourceError } from 'redevConfig'

const list = (sourceError && sourceError.list) || ''
const detail = (sourceError && sourceError.detail) || ''
const sourceErrorListCtrl = list ? require(`redevelopment/outputManage/sourceError/${list.controllerName}`) : require('./sourceErrorListCtrl')
const detailSourceErrorCtrl = detail ? require(`redevelopment/outputManage/sourceError/${detail.controllerName}`) : require('./detailSourceErrorCtrl')
export default angular
    .module('outputManage.FOManage.sourceError', [])
    .config(['$stateProvider', config])
    .controller('sourceErrorCtrl', sourceErrorCtrl)
    .controller('sourceErrorListCtrl', sourceErrorListCtrl.default)
    .controller('detailSourceErrorCtrl', detailSourceErrorCtrl.default)
    .name

function config ($stateProvider) {
    // 'ngInject';
    $stateProvider
        .state(sourceErrorRouter.state, sourceErrorRouter.config)
        .state(sourceErrorListRouter.state, sourceErrorListRouter.config)
        .state(sourceErrorDetailRouter.state, sourceErrorDetailRouter.config)
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/sourceError/index.js